var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"splash-container"},[_c('div',{staticClass:"splash-nav"},[_c('navigation-bar',{staticClass:"bg-white lg:bg-transparent"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }